import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-barcode",
  "use": "icon-si-glyph-barcode-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-barcode\" id=\"icon-si-glyph-barcode\"><title>874</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(1.000000, 2.000000)\" fill=\"#434343\"><rect x=\"13\" y=\"0\" width=\"1.953\" height=\"10.914\" class=\"si-glyph-fill\" /><rect x=\"10\" y=\"0\" width=\"1.967\" height=\"10.914\" class=\"si-glyph-fill\" /><rect x=\"8\" y=\"0\" width=\"0.95\" height=\"10.914\" class=\"si-glyph-fill\" /><rect x=\"4\" y=\"0\" width=\"1.972\" height=\"10.914\" class=\"si-glyph-fill\" /><rect x=\"2\" y=\"0\" width=\"0.973\" height=\"10.914\" class=\"si-glyph-fill\" /><rect x=\"0\" y=\"0\" width=\"0.973\" height=\"10.914\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-barcode.svg
// module id = 9rkQ
// module chunks = 62